import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { cn } from '@/lib/utils';
import { ErrorAlertVariants } from '@/types/alerts';
import { AlertCircle, InfoIcon, XCircle } from 'lucide-react';
import { FC, PropsWithChildren, ReactNode } from 'react';

type Props = { variant: ErrorAlertVariants; className?: string };

const iconMap: Record<ErrorAlertVariants, ReactNode> = {
  error:     <XCircle className="size-5" />,
  noResults: <InfoIcon className="size-5" />,
  info:      <InfoIcon className="size-5" />,
  warning:   <AlertCircle className="size-5" />,
};

export const ErrorAlert: FC<PropsWithChildren<Props & { title: React.ReactNode }>> = ({
  variant,
  className,
  title,
  children,
}) => {
  return (
    <Alert className={cn('gap-y-2', className)} variant={variant}>
      <AlertTitle className="flex items-center gap-2 text-base font-semibold">
        <span>{iconMap[variant]}</span>
        <span>{title}</span>
      </AlertTitle>
      <AlertDescription>{children}</AlertDescription>
    </Alert>
  );
};